import { initializeDatasets } from '@libs/datasets';

import datasets from './redux.datasets';

const initialState = {
    ...initializeDatasets(datasets),
};

export default (state = initialState, { type, payload, ...action }) => {
    switch (type) {
        case "handleCreate": {
            const { entity, value } = payload;
            const { data } = state[entity];
            let allEntries = [...data];
            allEntries.push(value);
            return { ...state, [entity]: { ...state[entity], data: allEntries } }
        }
        case "handleUpdate": {
            const { entity, value, key } = payload;
            const { data } = state[entity];
            let allEntries = [...data];
            const index = allEntries.findIndex((item) => (item[key] === value[key]));
            allEntries.splice(index, 1, value);
            return { ...state, [entity]: { ...state[entity], data: allEntries } };
        }
        case "handleDelete": {
            const { entity, value, key } = payload;
            const { data } = state[entity];
            let allEntries = [...data];
            allEntries = allEntries.filter((item) => (item[key] !== value[key]));
            return { ...state, [entity]: { ...state[entity], data: allEntries } };
        }
        default: {
            return state;
        }
    }
};
